import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MediaAttachmentComponent} from "../media-attachment/media-attachment.component";
import {TooltipDirective} from "../../shared/tooltip/tooltip.directive";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'synapi-item-label',
  standalone: true,
  imports: [CommonModule, MediaAttachmentComponent, TooltipDirective],
  templateUrl: './synapi-item-label.component.html',
  styleUrl: './synapi-item-label.component.scss'
})
export class SynapiItemLabelComponent {
  @Input() label: {id:string, name:string};
  labels = [
    {id: 'labels-marques-et-sites-classes.qualite-tourisme', image: 'qt-logo.png'},
    {id: 'labels-marques-et-sites-classes.accessibilite-et-handicap.label-tourisme-et-handicap', image: 'tourisme-et-handicap.png'},
    {id: 'labels-marques-et-sites-classes.accessibilite-et-handicap.label-var-accessible', image: 'var-accessible.png'},
    {id: 'labels-marques-et-sites-classes.accueil-velo', image: 'accueil-velo.png'},
    {id: 'labels-marques-et-sites-classes.vignobles-et-decouvertes', image: 'vignobles-et-decouvertes.png'},
    {id: 'labels-marques-et-sites-classes.environnement-et-developpement-durable.esprit-parc-national', image: 'esprit-parc-national.png'},
    {id: 'labels-marques-et-sites-classes.reseau-destination-le-var', image: 'reseau-destination-levar.png'}
  ];
  @Input() size = 70;
  baseUrl = !environment.production ?"https://visitvar.fr/wp-content/themes/visitvar/assets/ui/labels/" : location.protocol + '//' + location.host+'/assets/labels/';

}
